import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import ShuffleIcon from "@mui/icons-material/Shuffle";
import SettingsSharpIcon from "@mui/icons-material/SettingsSharp";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useChatContext } from "../chat-context";
import { CustomIconButton } from "../../../shared/components";

const BUTTON_LABELS = {
  SEND: "Send",
  SEARCH_ALL_WORDS: "Search All Words",
  RANDOM_QUESTION: "Random Question",
  ABOUT_CHATBOT: "About This Chatbot",
  OPEN_SETTINGS: "Open Settings",
  CLEAR_CHAT_HISTORY: "Clear Chat History",
} as const;

type ChatActionsProps = {
  handleClearChatDialogOpen: () => void;
  handleSettingsDialogOpen: () => void;
  handleInfoDialogOpen: () => void;
  handleSuggestionsDialogOpen: () => void;
  isLoading: boolean;
};

export const ChatActions = ({
  handleClearChatDialogOpen,
  handleSettingsDialogOpen,
  handleInfoDialogOpen,
  handleSuggestionsDialogOpen,
  isLoading,
}: ChatActionsProps) => {
  const { messages, handleSend, getQuestion } = useChatContext();
  const isChatEmpty = messages.length === 0;
  const handleSendClick = () => {
    if (!isLoading) {
      handleSend(false);
    }
  };
  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={handleSendClick}
        disabled={isLoading}
        sx={{
          height: "56px",
          marginLeft: "10px",
        }}
      >
        <b>{BUTTON_LABELS.SEND}</b>
      </Button>
      <CustomIconButton
        title={BUTTON_LABELS.SEARCH_ALL_WORDS}
        onClick={handleSuggestionsDialogOpen}
        disabled={false}
        icon={<SearchIcon />}
      />
      <CustomIconButton
        title={BUTTON_LABELS.RANDOM_QUESTION}
        onClick={getQuestion}
        disabled={isLoading}
        icon={<ShuffleIcon />}
      />
      <CustomIconButton
        title={BUTTON_LABELS.ABOUT_CHATBOT}
        onClick={handleInfoDialogOpen}
        disabled={false}
        icon={<InfoOutlinedIcon />}
      />
      <CustomIconButton
        title={BUTTON_LABELS.OPEN_SETTINGS}
        onClick={handleSettingsDialogOpen}
        disabled={false}
        icon={<SettingsSharpIcon />}
      />
      <CustomIconButton
        title={BUTTON_LABELS.CLEAR_CHAT_HISTORY}
        onClick={handleClearChatDialogOpen}
        disabled={isLoading || isChatEmpty}
        icon={<DeleteIcon />}
      />
    </>
  );
};
